export default __webpack_public_path__ + "static/media/upload_img.2bdd9de4.svg";